/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVersionFileFormatForCycloneDX extends models.AppSecopsSbomVersionFileFormat {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsSbomVersionFileFormatForCycloneDX");
    }

    getFixupPrototypeFunction() { return AppSecopsSbomVersionFileFormatForCycloneDX.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVersionFileFormatForCycloneDX>): AppSecopsSbomVersionFileFormatForCycloneDX {
        let obj = Object.assign(new AppSecopsSbomVersionFileFormatForCycloneDX(), model);
        AppSecopsSbomVersionFileFormatForCycloneDX.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVersionFileFormatForCycloneDX>): AppSecopsSbomVersionFileFormatForCycloneDX {
        if (!model) return null;
        return AppSecopsSbomVersionFileFormatForCycloneDX.newInstance(<AppSecopsSbomVersionFileFormatForCycloneDX> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVersionFileFormatForCycloneDX) {
        if (!obj) return;

        models.AppSecopsSbomVersionFileFormatForCycloneDX.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVersionFileFormatForCycloneDX): boolean {
        if (models.AppSecopsSbomVersionFileFormat.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsSbomVersionFileFormatForCycloneDX.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * CycloneDX schema version of the Software Bill of Materials (SBOM) document.
     */
    version: models.SBOMVersionCycloneDxFileFormatVersion;

}
